import script from "./SummaryView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SummaryView.vue?vue&type=script&lang=ts&setup=true"

import "./SummaryView.vue?vue&type=style&index=0&id=667cd782&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-667cd782"]])

export default __exports__